var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
        {
            'open': _vm.accordionOpen,
        },
        'accordion-item d-block'
    ],on:{"click":function($event){_vm.accordionOpen = !_vm.accordionOpen}}},[_c('h3',{staticClass:"accordion-title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n        "),_c('icon',{attrs:{"icon":_vm.accordionOpen ? 'min' : 'plus'}})],1),_vm._v(" "),_c('div',{staticClass:"accordion-inner mt-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }